<div class="eui-date-range-selector {{ styleClass }}" attr.data-e2e="{{ e2eAttr }}">
    <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate" [comparisonStart]="comparisonStart" [comparisonEnd]="comparisonEnd">
        <input
            matStartDate
            placeholder="{{ firstInputPlaceholder }}"
            aria-label="Start date"
            (click)="picker.open()"
            [value]="startDateDefaultValue"
            (dateInput)="onFirstDateChange($event)">
        <input
            matEndDate
            placeholder="{{ secondInputPlaceholder }}"
            aria-label="End date"
            (click)="picker.open()"
            [value]="endDateDefaultValue"
            (dateInput)="onSecondDateChange($event)">
    </mat-date-range-input>
    <mat-date-range-picker #picker></mat-date-range-picker>
    <button
        *ngIf="!noButton"
        class="eui-date-range-selector__toggler eui-date-range-selector__toggler-{{ !togglerLabel ? 'icon' : 'label' }}"
        (click)="picker.open()"
        euiButton
        euiSecondary
        euiIconButton
        [euiDisabled]="disableButton"
        aria-haspopup="dialog">
        <span *ngIf="!togglerLabel" euiIcon aria-label="Open Calendar" iconClass="{{ togglerIcon }}"></span>
        <span *ngIf="togglerLabel">{{ togglerLabel }}</span>
    </button>
</div>
